import { Pencil } from 'lucide-react';

interface EditableFieldWrapperProps {
  children: React.ReactNode;
  isEditing: boolean;
  onEdit: () => void;
  className?: string;
  tooltipText?: string;
}

export function EditableFieldWrapper({
  children,
  isEditing,
  onEdit,
  className = '',
  tooltipText = 'Click to edit'
}: EditableFieldWrapperProps) {
  return (
    <div
      onClick={onEdit}
      role="button"
      tabIndex={0}
      title={tooltipText}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onEdit();
        }
      }}
      className={`relative group cursor-pointer transition-all duration-200 ${
        isEditing
          ? 'ring-2 ring-blue-500'
          : 'hover:ring-1 hover:ring-dashed hover:ring-gray-400'
      } ${className}`}
    >
      {children}
      {!isEditing && (
        <Pencil
          aria-hidden
          className="absolute top-2 right-2 h-4 w-4 text-gray-400 group-hover:text-gray-600 transition-colors"
        />
      )}
    </div>
  );
}
